import React from "react"
import { setColor, setRem, media, setFlex } from "../../style"
import styled from "styled-components"
import Img from "gatsby-image"
import Container from "@material-ui/core/Container"

const PeopleLoveOurOffers = ({ images, miscText, miscText2 }) => {
  return (
    <>
      <Container maxWidth="sm" style={{ marginTop: "20px" }}>
        <Img fluid={images[6].fluid} />
      </Container>
      <Wrapper>
        <div className="pl-img">
          <Img fluid={images[8].fluid} className="photo" />
        </div>
        <div
          className="text-box"
          dangerouslySetInnerHTML={{ __html: miscText.miscText }}
        />
      </Wrapper>
      <Container maxWidth="md" style={{ marginTop: "20px" }}>
        <Img fluid={images[10].fluid} />
      </Container>
      <Wrapper>
        <div className="pl-img item-3">
          <Img fluid={images[9].fluid} className="photo" />
        </div>

        <div 
          className="text-box item-2"
          dangerouslySetInnerHTML={{__html: miscText2.miscText2}}
        />
      </Wrapper>
      <Img fluid={images[7].fluid} />
    </>
  )
}

export default PeopleLoveOurOffers

const Wrapper = styled.div`
  padding: ${setRem(5)};
  width: 95vw;
  margin: ${setRem(20)} auto;

  ${media.tablet`
   
    display: flex;
        justify-content: space-between;   
        justify-items: center;
        align-items: center;
        flex-wrap: wrap;
   
  `}

  .item-1 {
    order: 1;
  }
  .item-2 {
    order: 2;
  }
  .item-3 {
    order: 3;
  }
  .item-4 {
    order: 4;
  }

  .pl-img {
    margin: 1rem 0;
    position: relative;
    ${media.tablet`
            flex: 0 0 calc(50% - 1rem);
            ${setFlex};
        `}
  }
  .photo {
    display: block;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    ${media.tablet`
        width: 80%;
        height: 80%;
        `}
  }

  .text-box {
    margin: 0 0;
    color: ${setColor.mainGrey};
    padding: 0rem;
    ${media.tablet`
            padding: 3.3em;
            flex: 0 0 calc(50% - 1rem);
            font-size: ${setRem(18)};
        `}
  }
`
